// Portado de src/components/CardsAtendimento.astro (site Astro).
import { MAPS_BUSCA, NAP } from "@/lib/itv/site";
import { useAgendamentoLink } from "@/lib/itv/agendamento";

export function CardsAtendimento() {
  const agendar = useAgendamentoLink();
  return (
    <div className="cards-atendimento">
      <div className="card-atendimento">
        <span className="card-icone">
          <img src="/icones/map-pin.svg" loading="lazy" width={20} height={20} alt="" />
        </span>
        <div className="card-cabecalho">
          <p className="card-rotulo">ATENDIMENTO PRESENCIAL</p>
          <h3>
            {NAP.cidade} - {NAP.uf}
          </h3>
        </div>
        <hr className="card-regua" />
        <a className="card-texto card-endereco-link" href={MAPS_BUSCA}>
          {NAP.logradouro} - {NAP.bairro}, {NAP.cidade}-{NAP.uf}, CEP {NAP.cep}.
        </a>
        <p className="card-selo">CONSULTAS COM HORA MARCADA</p>
        <a className="btn-ouro card-btn" href={agendar}>
          Agendar presencial
        </a>
      </div>

      <div className="card-atendimento">
        <span className="card-icone">
          <img src="/icones/video.svg" loading="lazy" width={20} height={20} alt="" />
        </span>
        <div className="card-cabecalho">
          <p className="card-rotulo">TELECONSULTA</p>
          <h3>Todo o Brasil</h3>
        </div>
        <hr className="card-regua" />
        <p className="card-texto">
          Avaliação e acompanhamento a distância, com análise de histórico, sintomas, hábitos e
          exames. Onde você estiver.
        </p>
        <p className="card-selo">PARA TODO O BRASIL</p>
        <a className="btn-ouro card-btn" href={agendar}>
          Agendar teleconsulta
        </a>
      </div>
    </div>
  );
}
